import OrderProductModal from "./order_product_modal.vue"
import ProductMediaGallery from "./product_media_gallery.vue"
import { Product, ProductTag, ProductDependency } from "../models"

import { Api, ListResponse } from "@/api"

import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"
import showdown from "showdown"
import * as $ from "jquery"

const converter = new showdown.Converter()

@Component({
  name: "ProductDetailPopover",
  components: { OrderProductModal, ProductMediaGallery },
})
export default class ProductDetailPopover extends Vue {
  @Prop({ required: true })
  productId!: string | null

  @Prop({ required: true })
  onClose!: () => void

  product: Product | null = null
  productLoading = false
  productTagListResponse: ListResponse<ProductTag> | null = null
  productTagsLoading = false
  productDependencyListResponse: ListResponse<ProductDependency> | null = null
  productDependenciesLoading = false
  orderProductModalVisible = false

  mounted() {
    $("body").css({ overflow: "hidden" })

    window.addEventListener("keydown", this.onKeydown)

    this.reloadData()
  }

  beforeDestroy() {
    $("body").css({ overflow: "" })

    window.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(event: KeyboardEvent) {
    if (event.code === "Escape") {
      this.onClose()
    }
  }

  reloadData() {
    this.reloadProduct()
    this.reloadProductTags()
    this.reloadProductDependencies()
  }

  @Watch("productId")
  onProductChange() {
    if (this.productId !== null) {
      this.reloadData()
    }
  }

  onBackdropPress(event: Event) {
    if (
      (event.target as HTMLElement).classList.contains(
        "product-detail-popover-backdrop",
      ) === true
    ) {
      this.onClose()
    }
  }

  async reloadProduct() {
    const api = Api.createFromEnv()

    this.productLoading = true
    this.product = await api
      .get<Product>("products", this.productId!)
      .catch(error => {
        console.error(error)

        alert("Das Produkt konnte leider nicht geladen werden.")

        return null
      })

    this.productLoading = false
  }

  async reloadProductTags() {
    const api = Api.createFromEnv()
    const options = {
      product__eq_id: this.productId!,
      include: "extraTag",
    }

    this.productTagsLoading = true
    this.productTagListResponse = await api
      .getList<ProductTag>("product_tags", options)
      .catch(error => {
        console.error(error)

        return null
      })

    this.productTagsLoading = false
  }

  async reloadProductDependencies() {
    const api = Api.createFromEnv()
    const options = {
      sourceProduct__eq_id: this.productId!,
      include: "extraTargetProduct",
    }

    this.productDependenciesLoading = true
    this.productDependencyListResponse = await api
      .getList<ProductDependency>("product_dependencies", options)
      .catch(error => {
        console.error(error)

        return null
      })

    this.productDependenciesLoading = false
  }

  getFormattedPrice(price: number) {
    return `${price.toFixed(2).replace(".", ",")} €`
  }

  onOrderClick() {
    this.orderProductModalVisible = true
  }

  onOrderCancelClick() {
    this.orderProductModalVisible = false
  }

  onOrderCreate() {
    this.orderProductModalVisible = false
  }

  compileMarkdown(source) {
    return converter.makeHtml(source)
  }
}
